module.exports = __webpack_public_path__ + "static/media/20210410_180315_087_IMG_0266.444cc0b3.jpg";